import React from "../_snowpack/pkg/react.js";
import App from "../components/app.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {ArrowLeft, Edit, X} from "../components/icons.js";
import UploadArea from "../components/upload-area.js";
import {Routes} from "../typings/routes.js";
import {getUrl} from "../common/universal.js";
import ProductSidebar from "../components/product-sidebar.js";
import Inline from "../components/inline.js";
import {colors, media} from "../components/theme.js";
import SmallHeader from "../components/small-header.js";
import {
  ProductStoreProvider,
  useProductStore
} from "../stores/product.js";
import {useGlobalStore} from "../stores/global.js";
import Editor from "../components/editor.js";
import {getTranslatedSlug, mapSurface} from "../common/utils.js";
const validMimeTypes = ["application/pdf"];
export default function EditorPage(props) {
  return /* @__PURE__ */ React.createElement(App, {
    editor: true,
    ...props
  }, /* @__PURE__ */ React.createElement(ProductStoreProvider, {
    ...props
  }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Main, {
    ...props
  }), /* @__PURE__ */ React.createElement(Sidebar, {
    ...props
  }))));
}
function Main(props) {
  const [productStore, setProductStore] = useProductStore();
  const {
    product,
    config,
    article,
    quantity,
    options,
    cartItem,
    editorConfig,
    outsidePrintTemplateFile,
    insidePrintTemplateFile
  } = productStore;
  const [, setGlobalStore] = useGlobalStore();
  const printRequirements = editorConfig?.printRequirements ?? [];
  const backUrl = getUrl(Routes.product, {
    slug: getTranslatedSlug(product.page)
  }, {
    query: {
      item_id: cartItem?.id,
      product_config: config,
      article_id: article?.id,
      quantity,
      option_ids: options?.map(({id}) => id)
    }
  });
  const onUploadChange = (p) => (file) => {
    setProductStore((s) => ({
      ...s,
      [`${mapSurface(p)}PrintTemplateFile`]: file
    }));
  };
  const onSibebarButtonClick = () => setGlobalStore({sidebarActive: true});
  return /* @__PURE__ */ React.createElement(MainContainer, null, /* @__PURE__ */ React.createElement(Editor, {
    config: editorConfig,
    page: product.page,
    article,
    outsidePrintPath: outsidePrintTemplateFile?.path,
    insidePrintPath: insidePrintTemplateFile?.path,
    backgroundColor: product.category?.content.color.color,
    printRequirements
  }), /* @__PURE__ */ React.createElement(UploadContainer, null, printRequirements.map((r) => /* @__PURE__ */ React.createElement(Upload, {
    key: r,
    type: r,
    file: productStore[`${mapSurface(r)}PrintTemplateFile`],
    acceptMimeTypes: validMimeTypes,
    onChange: onUploadChange(r)
  }))), /* @__PURE__ */ React.createElement(BackButton, {
    href: backUrl
  }, /* @__PURE__ */ React.createElement(ArrowLeft, null)), /* @__PURE__ */ React.createElement(SidebarButton, {
    onClick: onSibebarButtonClick
  }, /* @__PURE__ */ React.createElement(Edit, {
    color: "#001529"
  })));
}
function Sidebar(props) {
  const [store, setStore] = useGlobalStore();
  const {sidebarActive} = store;
  const onCloseButtonClick = () => setStore({sidebarActive: false});
  return /* @__PURE__ */ React.createElement(SidebarContainer, {
    active: sidebarActive
  }, /* @__PURE__ */ React.createElement(CloseButton, {
    onClick: onCloseButtonClick
  }, /* @__PURE__ */ React.createElement(X, null)), /* @__PURE__ */ React.createElement(SmallHeader, {
    ...props
  }), /* @__PURE__ */ React.createElement(ProductSidebar, {
    editor: true
  }));
}
const Container = styled.div`
  display: flex;
  position: relative;
`;
const BackButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  position: absolute;
  top: 40px;
  left: 40px;

  ${media.mobile} {
    display: none;
  }
`;
const SidebarButton = styled.a`
  display: none;
  justify-content: center;
  align-items: center;
  background: white;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;

  ${media.mobile} {
    display: flex;
  }
`;
const CloseButton = styled.a`
  display: none;
  justify-content: center;
  align-items: center;
  background: ${colors.b};
  width: 40px;
  height: 40px;
  border-radius: 100%;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 200;

  svg path {
    stroke: white;
  }

  ${media.mobile} {
    display: flex;
  }
`;
const MainContainer = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 100vh;
`;
const UploadContainer = styled(Inline)`
  display: flex;
  position: absolute;
  top: 40px;
  right: 40px;
  ${media.mobile} {
    top: 20px;
    right: 20px;
  }
`;
const Upload = styled(UploadArea)``;
const SidebarContainer = styled.div`
  width: 410px;
  height: 100vh;
  overflow-y: auto;
  padding: 80px 40px 40px;
  background: white;

  ${media.mobile} {
    position: fixed;
    padding: 80px 20px 20px;
    width: 100%;
    height: 100vh;
    transform: translateX(-100%);
    transition: transform 0.3s;

    ${({active}) => active && "transform: translateX(0);"}
  }
`;
